import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import {  Cookies } from 'react-cookie';

import IssuanceMarketerRequests from "./IssuanceMarketerRequests";
import RenewalIssuanceMarketerRequests from "./RenewalIssuanceMarketerRequests";



const styles = theme => ({
    paperrtl: {
        marginTop: theme.spacing(0),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    }
    , paper: {
        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(20),
        },
    },


});

class IssuanceMarketersPanel extends Component {
    cookies=new Cookies();
    constructor(props) {
        super(props);
        this.state = {
            value:0,
        }}

    componentDidMount() {

    }
    handleChange= (event,newValue) => {
        this.setState({ value:newValue });
    }
    render() {
        const { classes } = this.props;
        const { value } = this.state;

        return (
            <div>
                <AppBar position="sticky"color="primary" >

                    <Tabs
                        style={{height:'60px',textAlign:'center'}}
                        value={value}
                        onChange={this.handleChange}
                        indicatorColor="secondary"
                        textColor={'#000000'}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="scrollable auto tabs example"
                    >

                        <Tab label="در حال صدور"/>
                        <Tab label="تمدیدی های من"/>



                    </Tabs>


                </AppBar>

                {(value===0)?<IssuanceMarketerRequests  props={this.props}/>:null}
                {(value===1)?<RenewalIssuanceMarketerRequests  props={this.props}/>:null}





            </div>
        );
    }
}

export default  withStyles(styles)(IssuanceMarketersPanel);
